export { Button } from './Button';
export { Field } from './Field';
export { Input, MultiSelect, Select, Textarea, type SelectOption } from './inputs';
export { Modal } from './Modal';
export { Table, type Column } from './Table';
export { ToastProvider, useToast } from './Toast';

export function Badge(props: {
  tone?: 'ok' | 'off' | 'neutral';
  children: React.ReactNode;
}): React.JSX.Element {
  const tone = props.tone && props.tone !== 'neutral' ? ` badge--${props.tone}` : '';
  return <span className={`badge${tone}`}>{props.children}</span>;
}

export function Avatar(props: { name: string; preset: number }): React.JSX.Element {
  return (
    <span className={`avatar preset-${props.preset % 10}`} aria-hidden="true">
      {props.name.charAt(0).toUpperCase()}
    </span>
  );
}
